const style = (theme) => {
  const output = {
    root: {
      display: 'flex',
      alignItems: 'center',
    },
    formBox: {
      position: 'relative',
      zIndex: 1,
      marginBottom: 35,
      marginTop: 35,
      backgroundColor: theme.colors[1],
      borderRadius: 10,
      padding: 10,
      display: 'flex',
      '& input': {
        position: 'relative',
        border: 'none',
        backgroundColor: 'transparent',
        fontSize: 14,
        width: '36vw',
        height: '100%',
        '&:focus': {
          outline: '0 none',
        },
      },
      '& > *:not(:last-child):not(:first-child)': {
        marginRight: 20,
      },
      '& > *:first-child': {
        marginRight: 5,
      },
    },
    suggestLine: {
      pointerEvents: 'none',
      color: theme.getRgba(theme.colors[0], 0.5),
      fontSize: 12,
      marginLeft: 20,
    },
    border: {
      display: 'block',
      width: 1,
      height: 'auto',
      marginTop: 6,
      marginBottom: 6,
      background: theme.getRgba(theme.colors[0], 0.16),
    },
    localizer: {
      '& svg': {
        fill: theme.colors[3],
      },
      '&:hover': {
        background: theme.colors[4],
        '& svg': {
          fill: theme.colors[1],
        },
      },
    },
    disabledButton: {
      pointerEvents: 'none',
      cursor: 'not-allowed',
      '& svg': {
        fill: theme.colors[5],
      },
      '&:hover': {
        background: 'transparent',
        '& svg': {
          fill: theme.colors[5],
        },
      },
    },
    search: {},
    inputDisabled: {
      pointerEvents: 'none',
    },
    hide: {
      opacity: 0,
    },
    spinner: {
      width: 20,
      height: 20,
      pointerEvents: 'none',
      transition: 'opacity 0.2s ease-in',
    },
    spinnerLoader: {
      stroke: theme.getRgba(theme.colors[3], 0.8),
      width: '100%',
      height: '100%',
      transition: 'all 1s ease-in',
      animation: '$rotate 2s linear infinite',
      '& .path': {
        strokeLinecap: 'round',
        animation: '$dash 1.5s ease-in-out infinite',
      },
    },
    '@keyframes rotate': {
      '100%': {
        transform: 'rotate(360deg)',
      },
    },
    '@keyframes dash': {
      '0%': {
        strokeDasharray: '1, 150',
        strokeDashoffset: '0',
      },
      '50%': {
        strokeDasharray: '90, 150',
        strokeDashoffset: '-35',
      },
      '100%': {
        strokeDasharray: '90, 150',
        strokeDashoffset: '-124',
      },
    },
    checkboxFilter: {
      transition: 'opacity .3s ease-in-out',
      opacity: 0,
      display: 'flex',
      alignItems: 'center',
      marginLeft: 50,
      '& > *:not(:last-child)': {
        marginRight: 30,
      },
    },
    visible: {
      opacity: 1,
    },
    checkbox: {
      display: 'flex',
      alignItems: 'center',
      '& svg': {
        width: 25,
        height: 25,
        fill: theme.colors[0],
        marginRight: 10,
      },
      '& input[type="checkbox"]': {
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0.001,
      },
      '& input[type="checkbox"] + span': {
        cursor: 'pointer',
        display: 'inline-flex',
        paddingLeft: 22,
        position: 'relative',
        zIndex: 1,
        alignItems: 'center',
        fontSize: 12,
        lineHeight: 1,
        color: theme.colors[5],
        '& a': {
          color: 'currentColor',
        },
        '&:before': {
          content: '""',
          position: 'absolute',
          cursor: 'pointer',
          zIndex: 1,
          top: '50%',
          left: 0,
          transform: 'translateY(-50%)',
          width: 13,
          height: 13,
          borderRadius: 10,
          border: `1px solid ${theme.getRgba(theme.colors[0], 0.2)}`,
          background: theme.colors[1],
          transition: 'all .2s ease-in-out',
        },
      },
      '& input[type="checkbox"]:checked + span': {
        color: theme.colors[3],
        '&:before': {
          background: theme.colors[3],
          boxShadow: `inset 0 0 0 2px ${theme.colors[1]}`,
        },
      },
    },
    checkboxDisable: {
      pointerEvents: 'none',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    root: {
      flexDirection: 'column',
      marginBottom: 35,
    },
    formBox: {
      width: '100%',
      marginBottom: 10,
    },
    checkboxFilter: {
      display: 'none',
    },
    suggestLine: {
      marginLeft: 0,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    root: {
      marginBottom: 15,
    },
    localizer: {},
    search: {},
    formBox: {
      marginBottom: 10,
      marginTop: 15,
      borderRadius: 50,
      boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.1)}`,
      '& input': {
        flex: 1,
        marginLeft: 10,
      },
      '& $localizer': {
        display: 'none',
      },
      '& $border': {
        display: 'none',
      },
      '& $search': {
        borderRadius: '50%',
      },
    },
  }

  return output
}
export default style
